import { logger } from '../core/logger';
import { environment } from '../environments/environment';
import { FerootConfig } from '../environments/environment.model';

const FEROOT_BASE_URL = 'https://pg.feroot.com/v1/bundle';
const DEFAULT_FEROOT_BUNDLE_ID = '35464b53-8b70-4908-9d47-cba415ea1d82';

/**
 * Injects the Feroot script with high priority
 * Adds the script to the head as early as possible
 */
export function injectFerootScript(config: FerootConfig): void {
  if (!config.enabled || document.querySelector(`script[src^="${FEROOT_BASE_URL}"]`)) {
    return;
  }

  try {
    logger.info(`Injecting Feroot script with bundleId: ${config.bundleId}`);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `${FEROOT_BASE_URL}/${config.bundleId}`;
    script.async = false;
    script.defer = false;

    // Insert as the first script in the head
    const firstScript = document.head.querySelector('script');
    if (firstScript) {
      document.head.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  } catch (error) {
    logger.error('Failed to inject Feroot script:', error);
  }
}

/**
 * Gets Feroot configuration from environment or defaults
 */
export function getFerootConfig(): FerootConfig {
  if (environment.feroot) {
    return environment.feroot;
  }

  return {
    bundleId: DEFAULT_FEROOT_BUNDLE_ID,
    enabled: true
  };
}
